import axios from "axios";
import { getFreshAccessToken } from "../../chat/api";
import { API_BASE } from "../extractorApi";

const builderApi = axios.create({ baseURL: `${API_BASE}/readpdf/template-builder` });

builderApi.interceptors.request.use(async (config) => {
  const token = await getFreshAccessToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const startBuild = (formData) => builderApi.post("/build/", formData).then(r => r.data);
export const selectPages = (draftId, payload) => builderApi.post(`/${draftId}/select-pages/`, payload).then(r => r.data);
export const getStatus = (draftId) => builderApi.get(`/${draftId}/status/`).then(r => r.data);
export const getDraft = (draftId) => builderApi.get(`/${draftId}/`).then(r => r.data);
export const patchDraft = (draftId, payload) => builderApi.patch(`/${draftId}/`, payload).then(r => r.data);
export const saveDraft = (draftId, payload) => builderApi.post(`/${draftId}/save/`, payload).then(r => r.data);

// refineDraft — omit field_keys entirely for the whole-template case so the backend
// still runs LLM intent-classification; pass a non-empty array for a scoped,
// single-field refine (skips classification server-side).
export const refineDraft = (draftId, feedback, fieldKeys) => {
  const payload = { feedback };
  if (Array.isArray(fieldKeys) && fieldKeys.length > 0) payload.field_keys = fieldKeys;
  return builderApi.post(`/${draftId}/refine/`, payload).then(r => r.data);
};

// ── Unified-workspace endpoints ──────────────────────────────────────────────

// POST /draft/ — start a blank (manual / import) draft, immediately "ready".
export const createBlankDraft = (payload) =>
  builderApi.post("/draft/", payload || {}).then(r => r.data);

// POST /from-template/{id}/ — seed a "reopened" draft from a saved template.
export const draftFromTemplate = (templateId) =>
  builderApi.post(`/from-template/${templateId}/`).then(r => r.data);

// PATCH /{draftId}/settings/ — change engine/model on an existing draft.
export const patchDraftSettings = (draftId, payload) =>
  builderApi.patch(`/${draftId}/settings/`, payload).then(r => r.data);

// GET /{draftId}/locate/?field_key= — approximate PDF highlight for a field's value.
export const locateField = (draftId, fieldKey) =>
  builderApi.get(`/${draftId}/locate/`, { params: { field_key: fieldKey } }).then(r => r.data);
